'use client'
import React, { useEffect } from 'react'
import { CommonInput } from '@/components';
import { useFormState, useFormStatus } from 'react-dom';
import { toast } from 'sonner';
import CustomButton from '@/components/common/CustomButton';
import { recoverPassword } from '@/actions/authActions';
import modalFeedbackReact from '@/components/feedBacks/Modal';

const emailInput = {
  name: 'email',
  title: 'Mail',
  placeHolder: 'example@email.com...',
  type: 'email',
  minlength: '1',
  maxlength: '50',
  required: true,
  width: 'w-full'
}

const RecoverForm = () => {

  const initialState = { status: '', message: '' };
  const [data, formAction] = useFormState(recoverPassword, initialState);

  // State to manage the submit button loading state
  useEffect(() => {
    if (data.status !== '') {
      if (data.status === 200) {
        modalFeedbackReact(data.message, 'Revisa tu mail y sigue los pasos para recuperar tu contraseña', false, true, "success")
      } else toast.error(data.message)
    }
  }, [data])

  return (
    <form action={formAction} className='flex flex-col w-full gap-y-6'>
      <CommonInput {...emailInput} />
      <RecoverButton />
    </form>
  )
}

function RecoverButton() {
  const { pending } = useFormStatus()
  return (
    <div>
      <CustomButton type='submit' disabled={pending} title={pending ? 'Enviando...' : 'Enviar mail'} colorType={pending ? 'disabled' : 'primary'} />
    </div>
  )
}

export default RecoverForm